export interface AnchorProps {
	anchorName: string;
}

export const Anchor: React.FC<AnchorProps> = ({ anchorName }) => <a id={anchorName}></a>;
